import React, { Fragment, useContext, useEffect } from "react";
import { IconButton } from "@mui/material";
import SaitTextField from "./SaitTextField";
import SearchIcon from "@mui/icons-material/Search";
import { formatLabel, isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";
import ClearIcon from "@mui/icons-material/Clear";
import { useSelector } from "react-redux";
import { ModuleContext } from "../utils/Constants";

export default function SaitSearchTextField(props) {
	const [openSearchWindow, setOpenSearchWindow] = React.useState(false);
	const [formattedValue, setFormattedValue] = React.useState("");

	const { name, searchWindow, filterSearchWindow, noClearable, onClear, afterChange, ...rest } = props;

	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === rest.objmod);

	useEffect(() => {
		let valueDescription = "";

		if (filterSearchWindow) {
			if (typeof props.value === "object" && !Array.isArray(props.value) && props.value) {
				if (props.value[name[0].gridName] || props.value[name[0].gridName] === 0) {
					valueDescription = formatLabel(props.description, props.value);
				}
			} else if (typeof props.value === "string" && props.allowwrite?.name && props.value) {
				valueDescription = props.value;
			}
		} else {
			if (props.value[name[0].storeName] || props.value[name[0].storeName] === 0) {
				valueDescription = formatLabel(props.description, props.value);
			}
		}

		setFormattedValue(valueDescription);
	}, [props.description, props.value, name, filterSearchWindow]);

	const handleOnSave = () => {
		if (onClear) {
			onClear();
		} else props.onChange({});
	};

	return isComponentVisible(objMod, rest.hidden) ? (
		<Fragment>
			<SaitTextField
				{...rest}
				searchWindow={true}
				value={rest.allowwrite?.name && typeof props.value === "string" && props.value ? props.value : formattedValue}
				width={600}
				disabled={rest.allowwrite?.name ? false : true}
				onChange={
					rest.allowwrite?.name
						? (e) => {
								props.onChange(e.target.value);
						  }
						: null
				}
				variant="outlined"
				sx={{
					...props.sx,
					...(!rest.allowwrite && {
						"& .MuiOutlinedInput-root.Mui-disabled": {
							backgroundColor: "#f7f7f7",
							borderRadius: 1,
						},
					}),
					...(rest.disabled && {
						"& .MuiOutlinedInput-root.Mui-disabled": {
							backgroundColor: "#f0f0f0",
							borderRadius: 1,
						},
					}),
				}}
				endadornment={
					formattedValue && !noClearable ? (
						<IconButton onClick={handleOnSave} disabled={isComponentDisabled(objMod, rest.disabled)}>
							<ClearIcon />
						</IconButton>
					) : (
						<IconButton onClick={() => setOpenSearchWindow(!openSearchWindow)} disabled={isComponentDisabled(objMod, rest.disabled)}>
							<SearchIcon />
						</IconButton>
					)
				}
			/>
			{searchWindow(openSearchWindow, () => setOpenSearchWindow(false), props.label, props.onChange)}
		</Fragment>
	) : null;
}
